import {Row, Col, Popconfirm, Button, Layout} from "antd";
import React, {useState} from "react";
import './index.sass';
import {withRouter} from "react-router-dom";
import {resetToken} from "../../store/token";
import store, {state} from "../../store";
import {sleep} from "../../utils/functions";
import {MERCHANT_STATE} from "../../store/merchant";
import {connect} from "react-redux";
import MerchantManager from "./MerchantManager";
import {MenuFoldOutlined, MenuUnfoldOutlined} from "@ant-design/icons";
const { Header } = Layout;

const CHeader = (props) => {
        let [changeMerchant, setChangeMerchant] = useState(false);
        let dispatch = store.dispatch;
        let merchant = props.merchant;
        const hide = () => {
            setChangeMerchant(false);
        }
        return (
            <Header className='header'>
                <div className='header-top'>
                    <div className="flex headerContainer">
                        <div className="left">
                            {React.createElement(props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                className: 'trigger',
                                onClick: () => props.setCollapsed(),
                            })}
                        </div>
                        <div className='flex right_f nameContainer'>
                            <span>欢迎 {merchant.name}</span>
                            <span className='mgr5 mgl5 pointer themeColor' onClick={async () => {
                                setChangeMerchant(true);
                            }}>切换身份</span>
                            <Popconfirm title='确认退出吗？' okText='确认' cancelText='取消' onConfirm={async () => {
                                dispatch(resetToken())
                                await sleep(1);
                                props.history.push({pathname: '/login'})
                            }}>
                                <Button  className='pointer mgl10 mgt15' type='primary'>退出</Button>
                            </Popconfirm>
                        </div>
                    </div>
                </div>
                <MerchantManager merchant={merchant} isVisible = {changeMerchant} hide = {hide}/>
            </Header>
        )

}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE]
    }
}
export default withRouter(connect(mapStateToProps)(CHeader));